import { jsonp } from '@ifeng-fe/ui_base';

const getMarketVarieties = async () => {
    const jsonpCallback = 'getMarketVarieties';
    const result = await jsonp(
        `https://shankapi.ifeng.com/finance/market/varieties/${jsonpCallback}`,
        {
            jsonpCallback,
            cache: false,
        },
    );

    if (result?.data && Object.keys(result.data).length > 0) {
        return result.data;
    } else {
        return {};
    }
};
// 获取所有行情数据
const getAllMarket = async () => {
    const jsonpCallback = 'getAllMarket';
    const result = await jsonp(
        `https://shankapi.ifeng.com/finance/newest/quoteAll/${jsonpCallback}`,
        {
            jsonpCallback,
            cache: false,
        },
    );

    if (result?.data?.length > 0) {
        return result.data;
    } else {
        return [];
    }
};

// 获取单个行情数据
const getSingleMarket = async quoteCode => {
    const jsonpCallback = `callbck_quote_${quoteCode}`;
    const result = await jsonp(
        `https://shankapi.ifeng.com/finance/newest/quote/${quoteCode}/${jsonpCallback}`,
        {
            jsonpCallback,
            cache: false,
        },
    );

    if (result?.data?.name) {
        return result.data;
    } else {
        return [];
    }
};

// 获取分时数据
const getStockTime = async quoteCode => {
    const jsonpCallback = `callbck_fenshi_${quoteCode}`;
    const result = await jsonp(
        `https://shankapi.ifeng.com/finance/fenshi/${quoteCode}/${jsonpCallback}`,
        {
            jsonpCallback,
            cache: false,
        },
    );

    if (result?.data) {
        return result.data;
    } else {
        return {};
    }
};

// 获取k线数据
const getKLine = async (quoteCode, resolution) => {
    const jsonpCallback = `callbck_${quoteCode}_${resolution}`;
    const result = await jsonp(
        `https://shankapi.ifeng.com/finance/history/${quoteCode}/${resolution}/${jsonpCallback}`,
        {
            jsonpCallback,
            cache: false,
        },
    );

    if (result?.data?.length) {
        return result.data;
    } else {
        return {};
    }
};

export { getMarketVarieties, getAllMarket, getStockTime, getSingleMarket, getKLine };
